export default {
    baseUrl: 'https://decapi.me',
    discordUrl: 'https://decapi.link/discord',
};
